
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="template-page">
      <!-- Left: Template List -->
      <div class="template-list-panel">
        <div class="list-header">
          <span>Templates</span>
          <p-button icon="pi pi-plus" [text]="true" severity="primary" pTooltip="New Template"
            (onClick)="addNewTemplate()" />
        </div>

        <div *ngIf="loading" class="list-loading">Loading...</div>

        <div *ngIf="!loading && templates.length === 0" class="list-empty">
          <p>No templates</p>
          <p-button label="Seed Defaults" icon="pi pi-download" size="small" (onClick)="seedDefaults()" />
        </div>

        <div *ngIf="!loading && templates.length > 0 && filteredTemplates.length === 0" class="list-empty">
          <p>No templates match your search</p>
        </div>

        <div *ngFor="let tpl of filteredTemplates" class="list-item"
          [class.list-item-active]="selectedTemplate?.id === tpl.id"
          [class.list-item-inactive]="!tpl.isActive"
          (click)="selectTemplate(tpl)">
          <span class="list-item-name">{{ tpl.name }}</span>
          <p-tag [value]="tpl.templateType" [severity]="tpl.isActive ? 'info' : 'secondary'" [style]="{ fontSize: '0.6rem' }" />
        </div>
      </div>

      <!-- Right: Editor -->
      <div class="template-editor-panel">
        <!-- No template selected -->
        <div *ngIf="!selectedTemplate" class="editor-empty">
          <i class="pi pi-envelope" style="font-size:2.5rem;color:var(--text-color-secondary);opacity:0.3;"></i>
          <p>Select a template or click <strong>+</strong> to create new</p>
        </div>

        <!-- Editor form -->
        <div *ngIf="selectedTemplate">
          <!-- Toolbar -->
          <div class="editor-toolbar">
            <span class="editor-toolbar-title">{{ isEditMode ? selectedTemplate.name : 'New Template' }}</span>
            <div class="editor-toolbar-actions">
              <p-button *ngIf="isEditMode" icon="pi pi-trash" [text]="true" severity="danger" size="small"
                pTooltip="Delete" (onClick)="deleteTemplate()" />
              <p-button icon="pi pi-save" label="Save" severity="primary" size="small"
                (onClick)="saveTemplate()" />
            </div>
          </div>

          <!-- Fields -->
          <div class="editor-fields">
            <div class="row-2">
              <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedTemplate.name.trim()">
                <label>Title <span class="req">*</span></label>
                <input pInputText [(ngModel)]="selectedTemplate.name" placeholder="Template name" (blur)="fieldTouched['name']=true" />
              </div>
              <div class="field">
                <label>Type</label>
                <p-select [(ngModel)]="selectedTemplate.templateType" [options]="templateTypeOptions"
                  optionLabel="label" optionValue="value" appendTo="body" />
              </div>
            </div>

            <div class="field" [class.field-invalid]="fieldTouched['subject'] && !selectedTemplate.subject.trim()">
              <label>Subject <span class="req">*</span></label>
              <input pInputText [(ngModel)]="selectedTemplate.subject" placeholder="Email subject line" (blur)="fieldTouched['subject']=true" />
            </div>

            <div class="row-2">
              <div class="field">
                <label>Receiver</label>
                <p-select [(ngModel)]="selectedTemplate.receiver" [options]="receiverOptions"
                  optionLabel="label" optionValue="value" appendTo="body" />
                <small class="field-hint">Which of the employee's addresses this is sent to.</small>
              </div>
            </div>

            <!-- Placeholders -->
            <div class="placeholder-row">
              <span class="placeholder-label">Insert:</span>
              <span *ngFor="let ph of placeholders" class="placeholder-chip" (click)="insertPlaceholder(ph)">{{ ph }}</span>
            </div>

            <!-- Rich text editor -->
            <div class="field">
              <label>Email Body</label>
              <p-editor #bodyEditor [(ngModel)]="selectedTemplate.body" [style]="{ height: '250px' }" />
            </div>

            <!-- Active + Preview -->
            <div class="row-2" style="align-items:center;">
              <div style="display:flex;align-items:center;gap:0.5rem;">
                <p-checkbox [(ngModel)]="selectedTemplate.isActive" [binary]="true" inputId="active" />
                <label for="active" style="cursor:pointer;font-size:0.85rem;">Active</label>
              </div>
              <div style="text-align:right;">
                <p-button [label]="showPreview ? 'Hide Preview' : 'Preview'" icon="pi pi-eye" [text]="true"
                  severity="info" size="small" (onClick)="showPreview = !showPreview" />
              </div>
            </div>

            <!-- Preview moved to popup dialog -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Email Preview Dialog -->
<p-dialog
  [visible]="showPreview"
  (visibleChange)="showPreview = $event"
  header="Email Preview"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [style]="{ width: '700px', maxHeight: '90vh' }">
  <div class="preview-dialog-content">
    <div class="preview-subject"><strong>Subject:</strong> {{ getPreviewSubject() }}</div>
    <div class="preview-body" [innerHTML]="getPreviewHtml()"></div>
  </div>
</p-dialog>
